import { tokens } from 'src/design-system';

const styles = () => ({
  summary: {
    display: 'flex',
    marginBottom: tokens.spacing.md,
    padding: `${tokens.spacing.ms}px ${tokens.spacing.md}px`,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.colors.bgSubtle,
  },
  summaryBlock: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:first-child)': {
      marginLeft: tokens.spacing.xxl,
    },
  },
  summaryLabel: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
  },
  summaryValue: {
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.bold,
    color: tokens.colors.text,
  },
  field: {
    marginBottom: tokens.spacing.md,
  },
  fieldLabel: {
    display: 'block',
    marginBottom: tokens.spacing.xs,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.text,
  },
  select: {
    width: '100%',
  },
});

export default styles;
